import React from "react";
import { getCampaignBadgesConfig } from "../../../../utils/flightCampaignConfig.js";
import { FlightCardBadge } from "./FlightCardBadge.js";
import { FlightCardBadges } from "./FlightCardBadges.js";
const FareCardCampaignBadges = ({ fareOffer, baseOffer }) => {
    const baseOfferBadgeStyles = new Set(getCampaignBadgesConfig(baseOffer.campaignDisplay?.badges).map((badge) => badge.style));
    const visibleCampaignBadges = getCampaignBadgesConfig(fareOffer.campaignDisplay?.badges).filter((badge) => !baseOfferBadgeStyles.has(badge.style));
    if (visibleCampaignBadges.length === 0) {
        return null;
    }
    return (React.createElement(FlightCardBadges, null, visibleCampaignBadges.map((badge, idx) => (React.createElement(FlightCardBadge, { ...badge, key: `fare-card-campaign-badge-${idx}`, alternative: false, isInteractive: !!badge.ariaLabel, isFocusable: !!badge.ariaLabel, flightToken: fareOffer.token, ariaLabel: badge.ariaLabel })))));
};
export default FareCardCampaignBadges;
